module.exports = __webpack_public_path__ + "img/corona.60ffccbb.svg";